<template>
  <el-container>
    <el-header class="order-layout">
      <Header title="填写、核对并提交订单信息" />
    </el-header>
    <el-main>
      <div style="width: 1226px; margin: 0 auto; overflow: hidden;padding-bottom:20px;">
        <div class="order-confirm-main bg-white pd-10">
          <h4 class="page-title"></h4>
          <div class="goods-info" v-if="!info" style="text-align: center; padding: 20px 0; color: red;">
            <h1 style="font-size: 26px;">{{ showErrorMsg() }}</h1>
          </div>
          <div class="goods-info" v-else>
            <el-row type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">服务方案</h3>
            </el-row>
            <el-descriptions class="margin-top" :column="6" border>
              <el-descriptions-item label="服务名称" :span="2">
                <el-input :value="info.ServeName"
              /></el-descriptions-item>
              <el-descriptions-item label="服务编号" :span="2"
                ><el-input :value="info.ServeNo"
              /></el-descriptions-item>
              <el-descriptions-item label="服务需求" :span="2"
                ><el-input :value="info.ServiceNeeds"
              /></el-descriptions-item>
              <el-descriptions-item label="检测资质" :span="2"
                ><el-input :value="info.Qualification"
              /></el-descriptions-item>
              <el-descriptions-item label="检测周期" :span="2"
                ><el-input :value="info.Cycle"
              /></el-descriptions-item>
              <el-descriptions-item label="接样实验室" :span="2"
                ><el-input :value="info.LabName"
              /></el-descriptions-item>
              <el-descriptions-item v-if="false" label="图片" :span="6"
                ><el-row
                  type="flex"
                  justify="flex-start"
                  align="middle"
                  style="flex-wrap: wrap"
                >
                  <div
                    class="img-box"
                    v-for="(p, i) in info.ServicePics"
                    :key="i"
                  >
                    <img :src="getImgFullPath(p.url)" />
                  </div>
                </el-row>
              </el-descriptions-item>
            </el-descriptions>

            <el-row type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">检测服务</h3>
            </el-row>
            <el-descriptions class="margin-top spc-desc" :column="1" border>
              <template v-for="(item, index) in info.Items">
                <el-descriptions-item :key="'ItemName' + index">
                  <template slot="label">
                    <span class="item-std-label">
                      <small>{{ item.ItemName }}</small>
                    </span></template
                  >
                  <span class="text-dark">{{ item.StdName }}</span>
                  <!-- <el-input :value="item.StdName" /> -->
                </el-descriptions-item>
              </template>
            </el-descriptions>
            <template v-if="info.Servers && info.Servers.length && info.Servers.filter(x=>x.IsBuy === '1').length">
              <el-row  v-if="info.Servers && info.Servers.length" type="flex" justify="space-between" align="middle">
                <h3 class="tit-title">附加服务</h3>
              </el-row>
              <template v-for="(item, index) in info.Servers">
                <el-descriptions
                  class="margin-top"
                  :column="7"
                  border
                  :key="item.ID"
                  v-if="item.IsBuy === '1'"
                >
                  <el-descriptions-item :span="3">
                    <template slot="label"> <span> 检测名称 </span></template>
                    <el-input :value="item.ServeName" />
                  </el-descriptions-item>
                  <el-descriptions-item :span="3">
                    <template slot="label"> <span> 检测标准 </span></template>
                    <el-input :value="item.StdTitle" />
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="数量"
                    :span="1"
                    :key="'Num' + index"
                  >
                    <el-input :value="item.Num" />
                  </el-descriptions-item>
                  <el-descriptions-item :span="4" :key="'PriceType1' + index">
                    <template slot="label">
                      <span
                        class="item-price-label"
                        v-if="item.PriceType.toString() === '1'"
                      >
                        统一标价
                      </span>
                      <span class="item-price-label" v-else> 区间标价 </span>
                    </template>
                    <span
                      id="item-price"
                      class="item-price"
                      v-if="item.PriceType.toString() === '1'"
                      >{{ item.ShopPrice }}</span
                    >
                    <div class="item-line-2" v-else>
                      <div
                        v-for="sp in item.ShopSectionPrice"
                        :key="sp.key"
                        style="margin-left: 40px; width: 100%"
                      >
                        <span>
                          <span>数量</span>
                          <span class="item-price-type">{{
                            sp.s.toString() === "1" ? "第" : "每"
                          }}</span>
                          <b class="item-price-type">{{ sp.f }}-{{ sp.t }}</b>
                          <span>({{ sp.p > 0 ? "单价" : "总价" }})</span>
                          <span class="item-price item-price-2">{{
                            sp.p > 0 ? sp.p : sp.cp
                          }}</span></span
                        >
                      </div>
                    </div>
                  </el-descriptions-item>
                </el-descriptions>
              </template>
            </template>
            <el-row v-if="info.UrgentPrice > 0 || info.CEnReportPrice > 0 " type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">其它服务</h3>
            </el-row>
            <el-row type="flex" justify="flex-start" align="middle" v-if="info.UrgentPrice > 0 || info.CEnReportPrice > 0 ">
              <el-checkbox
                size="medium"
                border
                v-model="info.IsUrgent"
                v-if="info.UrgentPrice > 0"
              >
                加急
                <span class="item-price item-price-2">{{
                  info.UrgentPrice
                }}</span>
              </el-checkbox>
              <el-checkbox
                size="medium"
                border
                v-model="info.IsEnReport"
                v-if="info.CEnReportPrice > 0"
              >
                英文报告
                <span class="item-price item-price-2">{{
                  info.CEnReportPrice
                }}</span>
              </el-checkbox>
            </el-row>

            <el-row type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">申请人信息</h3>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-document-copy"
                @click.stop.prevent="onSelectHistoryOrderClick()"
              >引用历史订单信息</el-button>
            </el-row>
            <el-form
              :model="applyInfo"
              :rules="applyInfoRule"
              ref="applyInfoForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-descriptions class="margin-top" :column="2" border> 
                <el-descriptions-item>
                  <template slot="label"><span class="required"> 申请人名称 </span></template>
                  <el-form-item label="" prop="CompanyName">
                    <el-input v-model="applyInfo.CompanyName" placeholder="请输入申请人名称" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"><span class="required"> 申请人地址 </span></template>
                  <el-form-item label="" prop="CompanyAdd">
                    <el-input v-model="applyInfo.CompanyAdd" placeholder="请输入申请人地址" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"><span class="required">联系人</span></template>
                  <el-form-item label="" prop="Linker">
                    <el-input v-model="applyInfo.Linker" placeholder="请输入联系人" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"><span class="required">联系电话/手机</span></template>
                  <el-form-item label="" prop="LinkerPhone">
                    <el-input v-model="applyInfo.LinkerPhone" placeholder="请输入联系电话/手机" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"><span class="required">邮箱</span></template>
                  <el-form-item label="" prop="CompanyLinkEmail">
                    <el-input v-model="applyInfo.CompanyLinkEmail" placeholder="请输入邮箱" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"><span class="required">付款单位名称</span></template>
                  <el-form-item label="" prop="PayCompanyName">
                    <el-input v-model="applyInfo.PayCompanyName" placeholder="请输入付款单位名称" />
                  </el-form-item>
                </el-descriptions-item>
              </el-descriptions>
            </el-form>
            <el-row type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">委托信息</h3>
            </el-row>
            <el-form
              :model="proxyInfo"
              :rules="proxyInfoRule"
              ref="proxyInfoForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-descriptions class="margin-top" :column="7" border>
                <el-descriptions-item :span="2">
                  <template slot="label"><span class="required"> 委托单位名称 </span></template>
                  <el-form-item label="" prop="ProxyCustName">
                    <el-input
                      v-model="proxyInfo.ProxyCustName"
                      placeholder="请输入委托单位名称"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-search"
                        title="选择委托单位"
                        @click.stop.prevent="onSelectCustClick()"
                      ></el-button>
                    </el-input>
                  </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item :span="2">
                  <template slot="label"> 委托单位英文名称 </template>
                  <el-form-item label="" prop="ProxyCustNameEN">
                    <el-input
                      v-model="proxyInfo.ProxyCustNameEN"
                      placeholder="请输入委托单位英文名称"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item> -->
                <!-- <el-descriptions-item :span="2">
                  <template slot="label"> 统一社会信用代码 </template>
                  <el-form-item label="" prop="UscCode">
                    <el-input
                      v-model="proxyInfo.UscCode"
                      placeholder="请输入统一社会信用代码"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item :span="5">
                  <template slot="label"><span class="required"> 委托单位地址 </span></template>
                  <el-form-item label="" prop="ProxyAddress">
                    <el-input
                      v-model="proxyInfo.ProxyAddress"
                      placeholder="请输入委托单位地址"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item :span="6">
                  <template slot="label"> 委托单位英文地址 </template>
                  <el-form-item label="" prop="ProxyAddressEN">
                    <el-input
                      v-model="proxyInfo.ProxyAddressEN"
                      placeholder="请输入委托单位英文地址"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item :span="2">
                  <template slot="label"><span class="required"> 生产商名称 </span> </template>
                  <el-form-item label="" prop="ProdCustName">
                    <el-input
                      v-model="proxyInfo.ProdCustName"
                      placeholder="请输入生产商名称"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-paperclip"
                        title="引用委托客户"
                        @click.stop.prevent="
                          onRefProxyInfo('ProdCustName', 'ProdCustAddress')
                        "
                      ></el-button
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item :span="5">
                  <template slot="label"> <span class="required"> 生产商地址 </span> </template>
                  <el-form-item label="" prop="ProdCustAddress">
                    <el-input
                      v-model="proxyInfo.ProdCustAddress"
                      placeholder="请输入生产商地址"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                  <template slot="label"> <span class="required"> 制造商名称 </span> </template>
                  <el-form-item label="" prop="MakeName">
                    <el-input
                      v-model="proxyInfo.MakeName"
                      placeholder="请输入制造商名称"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-paperclip"
                        title="引用委托客户"
                        @click.stop.prevent="
                          onRefProxyInfo('MakeName', 'MakeAddress')
                        "
                      ></el-button
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item :span="5">
                  <template slot="label"> <span class="required"> 制造商地址 </span> </template>
                  <el-form-item label="" prop="MakeAddress">
                    <el-input
                      v-model="proxyInfo.MakeAddress"
                      placeholder="请输入制造商地址"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                
                <el-descriptions-item :span="2">
                  <template slot="label">
                    <span class="required">报告类型</span>
                  </template>
                  <el-form-item label="" prop="ReportLanguage">
                    <el-checkbox-group v-model="proxyInfo.ReportLanguage" style="padding:0 10px;">
                      <el-checkbox label="中文">中文</el-checkbox>
                      <el-checkbox label="英文">英文</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-descriptions-item>
              </el-descriptions>
            </el-form>



            <el-row type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">样品信息</h3>
            </el-row>
            <el-form
              :model="reportInfo"
              :rules="reportInfoRule"
              ref="reportInfoForm"
              label-width="0px"
              class="demo-ruleForm"
            >
              <el-descriptions class="margin-top" :column="2" border>
                <el-descriptions-item>
                  <template slot="label"> <span class="required">产品名称</span> </template>
                  <el-form-item label="" prop="SampleName">
                    <el-input
                      v-model="reportInfo.SampleName"
                      placeholder="请输入产品名称"
                    ></el-input>

                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> <span class="required">型号及参数</span> </template>
                  <el-form-item label="" prop="SampleModel">

                    <el-input
                    v-model="reportInfo.SampleModel"
                    placeholder="请输入型号及参数"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> <span class="required">产品数量</span> </template>
                  <el-form-item label="" prop="SampleNum">

                    <el-input
                    v-model="reportInfo.SampleNum"
                    placeholder="请输入产品名称"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> <span class="required">产品商标</span> </template>
                  <el-form-item label="" prop="SampleBrand">

                    <el-input
                    v-model="reportInfo.SampleBrand"
                    placeholder="请输入型号及参数"
                    ></el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> <span class="required">快递单号</span> </template>
                  <el-form-item label="" prop="TrackingNumber">
                    <el-input v-model="reportInfo.TrackingNumber" placeholder="请输入快递单号" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label"> <span class="required">寄样日期</span> </template>
                  <el-form-item label="" prop="SampleDispatchDate">
                    <el-date-picker style="width:100%" v-model="reportInfo.SampleDispatchDate" type="date" value-format="yyyy-MM-dd" placeholder="选择寄样日期" prefix-icon="el-icon" />
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <div class="div-v">
                      <span
                        :class="{
                          required: reportInfoRule.CQCNo[0].required,
                        }"
                        >CQC申请号</span
                      >
                      <a
                        href="https://www.cqc.com.cn"
                        title="打开CQC官网"
                        target="_blank"
                        >www.cqc.com.cn</a
                      >
                    </div>
                  </template>
                  <el-form-item label="" prop="CQCNo">
                      <el-input
                      v-model="reportInfo.CQCNo"
                      placeholder="请输入CQC申请号"
                      >
                      <a
                      href="https://www.cqc.com.cn"
                      slot="append"
                      title="打开CQC官网"
                      target="_blank"
                      >
                      <svg
                      t="1650552081323"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="9915"
                      width="18"
                      height="18"
                      >
                      <path
                      d="M758.422 502.69c-25.825 0-46.764 20.939-46.764 46.764v-35.073c0-25.825-20.939-46.764-46.764-46.764-25.825 0-46.764 20.939-46.764 46.764v-23.382c0-25.825-20.939-46.764-46.764-46.764s-46.764 20.939-46.764 46.764V327.325c0-25.825-20.939-46.764-46.764-46.764-25.825 0-46.764 20.939-46.764 46.764v362.783l-32.573-47.606c-16.406-23.976-49.127-30.118-73.126-13.712-23.976 16.406-30.118 49.15-13.712 73.126 0 0 78.567 119.698 99.373 146.137 56.737 72.093 135.156 118.799 216.083 110.542 97.157-9.913 178.065-58.412 178.065-175.322v-233.82c0.002-25.825-20.937-46.763-46.762-46.763z"
                      p-id="9916"
                      fill="#083090"
                      ></path>
                      <path
                      d="M343.111 507.408c12.256-12.733 11.869-32.991-0.865-45.247-52.178-50.221-71.981-124.603-51.681-194.119 14.409-49.344 47.505-90.307 93.191-115.341 45.687-25.034 98.023-30.886 147.366-16.476 102.664 29.98 161.797 137.894 131.817 240.558-4.954 16.964 4.782 34.733 21.747 39.687 16.963 4.953 34.732-4.783 39.687-21.748 19.201-65.754 11.465-135.383-21.784-196.061-33.25-60.678-87.773-104.669-153.526-123.871-65.754-19.2-135.384-11.465-196.061 21.785-60.678 33.25-104.669 87.773-123.871 153.526-13.186 45.153-13.743 93.102-1.613 138.665 12.13 45.563 36.456 86.887 70.346 119.506 6.208 5.975 14.202 8.944 22.187 8.944 8.395 0.001 16.779-3.282 23.06-9.808z"
                      p-id="9917"
                      fill="#083090"
                      ></path>
                    </svg>
                  </a>
                </el-input>
                  </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <span class="required">样品处置选项</span>
                  </template>
                  <el-form-item label="" prop="SampleDisposal">
                    <el-radio-group v-model="reportInfo.SampleDisposal" style="padding:0 10px;">
                      <el-radio label="自取">自取</el-radio>
                      <el-radio label="寄回">寄回</el-radio>
                      <el-radio label="销毁">销毁</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-descriptions-item>
                <template v-if="reportInfo.SampleDisposal=='寄回'">
                  <el-descriptions-item>
                    <template slot="label"> <span class="required">收件人姓名</span> </template>
                    <el-form-item label="" prop="RecipientName">
                      <el-input v-model="reportInfo.RecipientName" placeholder="请输入收件人姓名" />
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> <span class="required">收件人电话</span> </template>
                    <el-form-item label="" prop="RecipientTel">
                      <el-input v-model="reportInfo.RecipientTel" placeholder="请输入收件人电话" />
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> <span class="required">收件地址</span> </template>
                    <el-form-item label="" prop="RecipientAdd">
                      <el-input v-model="reportInfo.RecipientAdd" placeholder="请输入收件地址" />
                    </el-form-item>
                  </el-descriptions-item>
                </template>
              </el-descriptions>
            </el-form>
            <el-row type="flex" justify="space-between" align="middle">
              <h3 class="tit-title">订单附件</h3>
            </el-row>
            <el-row type="flex" justify="space-between" align="top" style="width:100%;border:1px solid #dcdfe6;margin-bottom:5px;">
              <el-col :span="12" style="padding:5px 10px;">
                <div class="text-error" style="font-size:12px;;border-bottom:1px solid #dcdfe6"><strong>资料要求</strong></div>
                <div class="ut-editor-viewmode" v-html="renderHtml(info.MaterialRequirements)" />
              </el-col>
              
              <el-col :span="12" style="padding:5px 10px;border-left:1px solid #dcdfe6">
                <div class="text-error" style="font-size:12px;;border-bottom:1px solid #dcdfe6"><strong>模板下载</strong></div>
                <upload-files :files="info.TemplateDownload" viewmode />
              </el-col>
            </el-row>
            <upload-files
              :files="info.OrderFile"
              :max="99"
              :acceptFileTypes="[
                'PDF',
                'DOC',
                'DOCX',
                'RAR',
                'ZIP',
                '7Z',
                'XLS',
                'XLSX',
                'PPT',
                'PPTX',
              ]"
              @filelist-change="onUploadFilesChange"
            />
            <template v-if="false">
              <el-row type="flex" justify="space-between" align="middle">
                <h3 class="tit-title">报告信息</h3>
              </el-row>
              <el-form
                :model="reportInfo"
                :rules="reportInfoRule"
                ref="reportInfoForm"
                label-width="0px"
                class="demo-ruleForm"
              >
                <el-descriptions class="margin-top" :column="3" border>
                  <el-descriptions-item v-if="false">
                    <template slot="label"> 报告用途 </template>
                    <el-form-item label="" prop="ReportUse">
                      <el-select
                        v-model="reportInfo.ReportUse"
                        placeholder="请选择报告用途"
                      >
                        <el-option
                          v-for="di in ReportUseList"
                          :key="di.ItemValue"
                          :label="di.ItemName"
                          :value="di.ItemValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 报告数量 </template>
                    <el-form-item label="" prop="ReportNum">
                      <el-input
                        readonly
                        v-model="reportInfo.ReportNum"
                        placeholder="请输入报告数量"
                      >
                        <el-tooltip
                          class="item"
                          slot="append"
                          effect="dark"
                          content="报告数量只支持一份，如果需要多份，请联系店铺客服"
                          placement="top"
                        >
                          <el-button
                            ><i class="el-icon-question"></i
                          ></el-button>
                        </el-tooltip>
                      </el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 报告语言 </template>
                    <el-form-item label="" prop="ReportLang">
                      <el-select
                        disabled
                        v-model="reportInfo.ReportLang"
                        placeholder="请选择报告语言"
                      >
                        <el-option
                          v-for="di in ReportLangList"
                          :key="di.ItemValue"
                          :label="di.ItemName"
                          :value="di.ItemValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 结论形式 </template>
                    <el-form-item label="" prop="ReportConclusion">
                      <el-select
                        v-model="reportInfo.ReportConclusion"
                        placeholder="请选择结论形式"
                      >
                        <el-option
                          v-for="di in ReportConclusionList"
                          :key="di.ItemValue"
                          :label="di.ItemName"
                          :value="di.ItemValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <div class="div-v">
                        <span
                          :class="{
                            required: reportInfoRule.CQCNo[0].required,
                          }"
                          >CQC申请号</span
                        >
                        <a
                          href="https://www.cqc.com.cn"
                          title="打开CQC官网"
                          target="_blank"
                          >www.cqc.com.cn</a
                        >
                      </div>
                    </template>
                    <el-form-item label="" prop="CQCNo">
                      <el-input
                        v-model="reportInfo.CQCNo"
                        placeholder="请输入CQC申请号"
                      >
                        <a
                          href="https://www.cqc.com.cn"
                          slot="append"
                          title="打开CQC官网"
                          target="_blank"
                        >
                          <svg
                            t="1650552081323"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="9915"
                            width="18"
                            height="18"
                          >
                            <path
                              d="M758.422 502.69c-25.825 0-46.764 20.939-46.764 46.764v-35.073c0-25.825-20.939-46.764-46.764-46.764-25.825 0-46.764 20.939-46.764 46.764v-23.382c0-25.825-20.939-46.764-46.764-46.764s-46.764 20.939-46.764 46.764V327.325c0-25.825-20.939-46.764-46.764-46.764-25.825 0-46.764 20.939-46.764 46.764v362.783l-32.573-47.606c-16.406-23.976-49.127-30.118-73.126-13.712-23.976 16.406-30.118 49.15-13.712 73.126 0 0 78.567 119.698 99.373 146.137 56.737 72.093 135.156 118.799 216.083 110.542 97.157-9.913 178.065-58.412 178.065-175.322v-233.82c0.002-25.825-20.937-46.763-46.762-46.763z"
                              p-id="9916"
                              fill="#083090"
                            ></path>
                            <path
                              d="M343.111 507.408c12.256-12.733 11.869-32.991-0.865-45.247-52.178-50.221-71.981-124.603-51.681-194.119 14.409-49.344 47.505-90.307 93.191-115.341 45.687-25.034 98.023-30.886 147.366-16.476 102.664 29.98 161.797 137.894 131.817 240.558-4.954 16.964 4.782 34.733 21.747 39.687 16.963 4.953 34.732-4.783 39.687-21.748 19.201-65.754 11.465-135.383-21.784-196.061-33.25-60.678-87.773-104.669-153.526-123.871-65.754-19.2-135.384-11.465-196.061 21.785-60.678 33.25-104.669 87.773-123.871 153.526-13.186 45.153-13.743 93.102-1.613 138.665 12.13 45.563 36.456 86.887 70.346 119.506 6.208 5.975 14.202 8.944 22.187 8.944 8.395 0.001 16.779-3.282 23.06-9.808z"
                              p-id="9917"
                              fill="#083090"
                            ></path>
                          </svg>
                        </a>
                      </el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 报告形式 </template>
                    <el-form-item label="" prop="ReportForm">
                      <el-select
                        v-model="reportInfo.ReportForm"
                        disabled
                        placeholder="请选择报告形式"
                      >
                        <el-option
                          v-for="di in ReportFormList"
                          :key="di.ItemValue"
                          :label="di.ItemName"
                          :value="di.ItemValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label"> 发放方式 </template>
                    <el-form-item label="" prop="ReportSend">
                      <el-select
                        v-model="reportInfo.ReportSend"
                        placeholder="请选择发放方式"
                      >
                        <el-option
                          v-for="di in ReportSendList"
                          :key="di.ItemValue"
                          :label="di.ItemName"
                          :value="di.ItemValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item
                    v-if="
                      reportInfo.ReportSend === 'Email' ||
                      reportInfo.ReportSend === 'ExpressAndEmail'
                    "
                  >
                    <template slot="label">
                      <span class="required">报告收取邮箱 </span></template
                    >
                    <el-form-item label="" prop="ReportEmail">
                      <el-input
                        v-model="reportInfo.ReportEmail"
                        placeholder="请输入报告收取邮箱"
                      ></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item
                    v-if="
                      reportInfo.ReportSend === 'Express' ||
                      reportInfo.ReportSend === 'ExpressAndEmail'
                    "
                  >
                    <template slot="label">
                      <span class="required">报告邮寄地址</span>
                    </template>
                    <el-form-item label="" prop="ReportPostID">
                      <el-input
                        v-model="reportInfo.ReportPostInfo"
                        readonly
                        placeholder="请输入报告邮寄地址"
                      >
                        <el-button
                          slot="append"
                          icon="el-icon-search"
                          title="选择委托客户"
                          @click.stop.prevent="onSelectAddressClick()"
                        ></el-button>
                      </el-input>
                    </el-form-item>
                  </el-descriptions-item>
                  <el-descriptions-item span="3">
                    <template slot="label"> 备注 </template>
                    <el-form-item label="" prop="Remark">
                      <el-input
                        v-model="reportInfo.Remark"
                        placeholder="请输入备注"
                      ></el-input>
                    </el-form-item>
                  </el-descriptions-item>
                </el-descriptions>
              </el-form>
              <el-divider />
            </template>

            <div class="top-line bg-white flex-fixed-bottom">
              <el-row
                type="flex"
                justify="space-between"
                align="middle"
                class="order-confirm-main"
                style="padding:0 10px!important"
              >
                <h3 class="item-price">{{ info.TotalPrice || 0.0 }}</h3>
                <el-row type="flex" justify="start" align="middle">
                  <el-row type="flex" justify="start" align="middle">
                    <el-checkbox v-model="acceptServiceAgreement" />
                    <h3 class="text-dark tit-title" style="padding-left: 5px">
                      我已认真阅读并同意
                    </h3>
                    <el-divider direction="vertical" />
                    <el-link
                      :underline="false"
                      @click.stop.prevent="
                        onGetServiceAgreementClick(info.ServiceAgreement)
                      "
                      >《{{ info.ServiceAgreementName || '服务协议' }}》</el-link
                    >
                    <el-divider
                      direction="vertical"
                      style="padding-right: 20px"
                    />
                  </el-row>
                  <div
                    disabled
                    :class="{
                      'save-btn': true,
                      disabled: !acceptServiceAgreement,
                    }"
                    @click.stop.prevent="onPostOrder('f=Status&v=0')"
                  >
                    <i class="el-icon-finished" />
                    <span style="margin-left: 5px">保存订单</span>
                  </div>
                  <div  v-if="info.GoodsDeptID !== 1000050"
                    :class="{
                      'user-btn': true,
                      disabled: !acceptServiceAgreement,
                    }"
                    @click.stop.prevent="onPostOrder('f=Status&v=10~20')"
                  >
                    <i class="el-icon-check" />
                    <span style="margin-left: 5px">提交订单</span>
                  </div>
                </el-row>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="order-layout">
      <Footer />
    </el-footer>

    <div v-if="enterpriseSelectorWndVisiable">
      <el-dialog
        title="选择认证企业"
        class="enterprise-edit-dialog"
        ref="NewsDialong"
        :visible.sync="enterpriseSelectorWndVisiable"
        :show-close="true"
        :close-on-click-modal="false"
        width="800px"
        destroy-on-close
      >
        <el-table
          :data="enterprises"
          border
          ref="table"
          height="360"
          highlight-current-row
          @row-click="onEnterpriseTableRowClick"
          @row-dblclick="onEnterpriseTableRowDblClick"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column
            sortable
            width="250"
            show-overflow-tooltip
            prop="Name"
            label="企业名称"
          ></el-table-column>
          <el-table-column
            sortable
            width="180"
            prop="Certificate"
            label="统一社会信用代码"
          ></el-table-column>
          <el-table-column
            min-width="180"
            sortable
            show-overflow-tooltip
            prop="Linker"
            label="联系人"
          ></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            icon="el-icon-check"
            type="primary"
            @click="onEnterpriseSelect()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <div v-if="addressSelectorWndVisiable">
      <el-dialog
        title="选择用户地址"
        class="enterprise-edit-dialog"
        ref="NewsDialong"
        :visible.sync="addressSelectorWndVisiable"
        :show-close="true"
        :close-on-click-modal="false"
        width="800px"
        destroy-on-close
        append-to-body
      >
        <el-table
          :data="userAddress"
          border
          ref="table"
          height="480"
          highlight-current-row
          @row-click="onAddressTableRowClick"
          @row-dblclick="onAddressTableRowDblClick"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column
            sortable
            width="180"
            prop="Linker"
            label="联系人"
          ></el-table-column>
          <el-table-column
            width="180"
            show-overflow-tooltip
            prop="CompanyName"
            label="单位名称"
          ></el-table-column>
          <el-table-column
            sortable
            width="180"
            prop="LinkTel"
            label="联系人电话"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            width="180"
            prop="Address"
            label="详细地址"
          ></el-table-column>
          <el-table-column prop="IsDefault" label="默认地址">
            <template v-slot="scope">
              <i
                class="el-icon-check"
                v-if="scope.row.IsDefault.toString() === '1'"
              />
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="default"
            @click="onAddressAdd()"
            >添 加</el-button
          >
          <el-button
            size="small"
            icon="el-icon-check"
            type="primary"
            @click="onAddressSelect()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <div v-if="dialogAddressEditVisible">
      <el-dialog
        title="编辑地址"
        class="enterprise-edit-dialog"
        ref="NewsDialong"
        :visible.sync="dialogAddressEditVisible"
        :show-close="true"
        :close-on-click-modal="false"
        width="600px"
        destroy-on-close
        append-to-body
      >
        <AddressEdit :dataForm="addressInfo" />
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            icon="el-icon-check"
            type="primary"
            @click.stop.prevent="onPostNewAddress()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <div v-if="serviceAgreementInfoVisiable">
      <el-dialog
        title="服务协议详情"
        class="enterprise-edit-dialog"
        ref="NewsDialong"
        :visible.sync="serviceAgreementInfoVisiable"
        :show-close="true"
        :close-on-click-modal="false"
        :lock-scroll="true"
        width="900px"
        append-to-body
        destroy-on-close
      >
        <div class="html-box" v-html="serviceAgreementInfo"></div>
      </el-dialog>
    </div>

    <!-- 历史订单选择弹窗 -->
    <div v-if="historyOrderSelectorVisible">
      <el-dialog
        title="选择历史订单"
        class="history-order-dialog"
        :visible.sync="historyOrderSelectorVisible"
        :show-close="true"
        :close-on-click-modal="false"
        width="900px"
        destroy-on-close
      >
        <el-row type="flex" justify="start" align="middle" style="margin-bottom: 15px;">
          <el-input
            v-model="historyOrderSearchKey"
            placeholder="请输入订单号/委托单位名称搜索"
            style="width: 300px;"
            size="small"
            clearable
          >
            <el-button slot="append" icon="el-icon-search" @click="loadHistoryOrders()"></el-button>
          </el-input>
        </el-row>
        <el-table
          :data="historyOrders"
          border
          ref="historyOrderTable"
          height="400"
          highlight-current-row
          @row-click="onHistoryOrderRowClick"
          @row-dblclick="onHistoryOrderRowDblClick"
          style="width: 100%"
          v-loading="historyOrderLoading"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            prop="OrderNo"
            label="订单号"
            width="190"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ProxyCustName"
            label="委托单位"
            width="240"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="CompanyName"
            label="申请人名称"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="Linker"
            label="联系人"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="LinkerPhone"
            label="联系电话"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="CreateTime"
            label="创建时间"
            width="180"
          ></el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 15px; text-align: right;"
          small
          background
          @current-change="onHistoryOrderPageChange"
          :current-page="historyOrderPagination.currentPage"
          :page-size="historyOrderPagination.pageSize"
          :total="historyOrderPagination.total"
          layout="total, prev, pager, next"
        ></el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            @click="historyOrderSelectorVisible = false"
          >取 消</el-button>
          <el-button
            size="small"
            icon="el-icon-check"
            type="primary"
            @click="onHistoryOrderSelect()"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
import Header from "@/components/Head"
import Footer from "@/components/Food"
import UploadFiles from "@/components/UploadFiles"
import { GetGoodsView, SaveGoodsOrder, GetList, GetServiceAgreement, GetItemDetailList, Add, GetHistoryOrderList } from "@/api/general-api"
import { getToken } from "@/utils/myAuth";
import AddressEdit from '@/components/FormData/UserAddress/index.vue'
import { convertToFormData } from '@/api/request'

export default {
  name: 'OrderConfirm',
  components: { Header, Footer, AddressEdit, UploadFiles },
  data() {
    var validateCQCNo = (rule, value, callback) => {
      if (!value || !/[\u4E00-\u9FA5]/g.test(value)) {
        callback();
      } else {
        callback(new Error('申请号不能输入汉字!'));
      }
    };
    return {
      currentEnterprise: null,
      enterpriseSelectorWndVisiable: false,
      currentAddress: null,
      addressSelectorWndVisiable: false,
      serviceAgreementInfoVisiable: false,
      serviceAgreementInfo: '',
      // 历史订单选择相关
      historyOrderSelectorVisible: false,
      historyOrders: [],
      currentHistoryOrder: null,
      historyOrderSearchKey: '',
      historyOrderLoading: false,
      historyOrderPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogAddressEditVisible: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      userSelectData: {
        ID: null,
        IdNums: []
      },
      info: null,
      acceptServiceAgreement: true,
      msg: "",
      applyInfo: {
        CompanyName: null,
        CompanyAdd: null,
        Linker: null,
        LinkerPhone: null,
        CompanyLinkEmail: null,
        PayCompanyName: null,
      },
      applyInfoRule:{
        CompanyName: [
          { required: true, message: '请输入申请人名称', trigger: 'change' }
        ],
        CompanyAdd: [
          { required: true, message: '请输入申请人地址', trigger: 'change' }
        ],
        PayCompanyName: [
          { required: true, message: '请输入付款单位名称', trigger: 'change' }
        ],
        Linker: [
          { required: true, message: '请输入联系人', trigger: 'change' }
        ],
        LinkerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'change' }
        ],
        CompanyLinkEmail: [
          { required: true, message: '请输入邮箱', trigger: 'change' }
        ],
        PayCompanyName: [
          { required: true, message: '请输入付款单位名称', trigger: 'change' }
        ],
      },
      proxyInfo: {
        ProxyCustName: null,
        ProxyCustNameEN: null,
        UscCode: null,
        ProxyAddress: null,
        ProxyAddressEN: null,
        MakeName: null,
        MakeAddress: null,
        ProdCustName: null,
        ProdCustAddress: null,
        ReportLanguage	:[],
      },
      proxyInfoRule: {
        ProxyCustName: [
          { required: true, message: '请输入委托单位名称', trigger: 'change' }
        ],
        ProxyAddress: [
          { required: true, message: '请输入委托单位地址', trigger: 'change' }
        ],
        ProdCustName: [
          { required: true, message: '请输入生产商名称', trigger: 'change' }
        ],
        ProdCustAddress: [
          { required: true, message: '请输入生产商地址', trigger: 'change' }
        ],
        MakeName: [
          { required: true, message: '请输入制造商名称', trigger: 'change' }
        ],
        MakeAddress: [
          { required: true, message: '请输入制造商地址', trigger: 'change' }
        ],
        
        ReportLanguage: [
          { required: true, message: '请选择报告类型', trigger: 'change' }
        ],
      },
      reportInfo: {
        SampleNum: '',
        SampleBrand: '',
        SampleModel: '',
        SampleName: '',
        TrackingNumber: '',
        SampleDispatchDate: '',
        ReportUse: '',
        ReportNum: 1,
        ReportLang: 'CN',
        ReportConclusion: 'MeasuredData',
        CQCNo: '',
        ReportForm: 'ElectronicReport',
        ReportSend: 'Email',
        ReportEmail: '',
        Remark: '',
        ReportPostID: '',
        ReportPostInfo: '',
        SampleDisposal: '',
        RecipientName: '',
        RecipientTel: '',
        RecipientAdd: '',
      },
      reportInfoRule: {
        CQCNo: [
          { required: false, trigger: 'blur', validator: validateCQCNo }
        ],
        ReportEmail: [
          { required: true, message: '请输入报告收取邮箱', trigger: 'change' }
        ],
        ReportPostID: [
          { required: true, message: '请输入报告邮寄地址', trigger: 'change' }
        ],
        SampleNum: [
          { required: true, message: '请输入产品数量', trigger: 'change' }
        ],
        SampleBrand: [
          { required: true, message: '请输入产品商标', trigger: 'change' }
        ],
        SampleModel: [
          { required: true, message: '请输入型号及参数', trigger: 'change' }
        ],
        SampleName: [
          { required: true, message: '请输入产品名称', trigger: 'change' }
        ],
        TrackingNumber: [
          { required: true, message: '请输入快递单号', trigger: 'change' }
        ],
        SampleDispatchDate: [
          { required: true, message: '请选择寄样日期', trigger: 'change' }
        ],
        SampleDisposal: [
          { required: true, message: '请选择样品处置选项', trigger: 'change' }
        ],
        RecipientName: [
          { required: true, message: '请输入收件人姓名', trigger: 'change' }
        ],
        RecipientTel: [
          { required: true, message: '请输入收件人电话', trigger: 'change' }
        ],
        RecipientAdd: [
          { required: true, message: '请输入收件地址', trigger: 'change' }
        ],
      },
      enterprises: [],
      userAddress: [],

      ReportUseList: [],
      ReportLangList: [],
      ReportConclusionList: [],
      ReportFormList: [],
      ReportSendList: [],
      TemplateDownload: [],
      addressInfo: {}
    }
  },
  mounted() {
    const query = this.$route.query
    Object.keys(query).forEach(key => {
      if (key === 'ID') {
        this.userSelectData.ID = query.ID
      } else {
        this.userSelectData.IdNums.push({
          ID: key,
          Num: query[key] || '1'
        })
      }
    })

    if (this.userSelectData.ID) {
      const token = getToken();
      if (!token) {
        localStorage.setItem('frmUrl', window.location.href)
        return this.$router.push("/login");
      }
      this.InitializeData()
    }

  },
  methods: {
    onPostNewAddress() {
      console.log(this.addressInfo)
      Add(
        convertToFormData({
          Name: 'UserAddress',
          data: JSON.stringify(this.addressInfo)
        })
      ).then((res) => {
        this.addressInfo = {}
        this.dialogAddressEditVisible = false;
        this.onSelectAddressClick()
      })
    },
    InitializeData() {
      Promise.all([
        GetItemDetailList({ ItemCode: 'ReportUse' }),
        GetItemDetailList({ ItemCode: 'ReportLang' }),
        GetItemDetailList({ ItemCode: 'ReportConclusion' }),
        GetItemDetailList({ ItemCode: 'ReportForm' }),
        GetItemDetailList({ ItemCode: 'ReportSend' })
      ]).then(resArr => {
        const [
          resReportUseList,
          resReportLangList,
          resReportConclusionList,
          resReportFormList,
          resReportSendList,
        ] = resArr
        resReportUseList.success && (this.ReportUseList = [...resReportUseList.data])
        resReportLangList.success && (this.ReportLangList = [...resReportLangList.data])
        resReportConclusionList.success && (this.ReportConclusionList = [...resReportConclusionList.data])
        resReportFormList.success && (this.ReportFormList = [...resReportFormList.data])
        resReportSendList.success && (this.ReportSendList = [...resReportSendList.data])
        this.getConfirmOrderInfo()
      }).catch(err => {
        this.$message.error('数据初始化失败！')
      })
    },
    escape2Html(str){
        var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
          return arrEntities[t];
        });
      },
    onGetServiceAgreementClick(ID) {
      const escape2Html = (str) => {
        var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
          return arrEntities[t];
        });
      };
      GetServiceAgreement({ ID }).then(res => {
        this.serviceAgreementInfo = res.success ? escape2Html(res.data.ServiceContent) : ''
        this.serviceAgreementInfoVisiable = true
      })
    },
    onAddressTableRowDblClick(row) {
      this.currentAddress = row
      this.onAddressSelect()
    },
    onAddressTableRowClick(row) {
      this.currentAddress = row
    },
    onAddressAdd() {
      this.addressInfo = {}
      this.dialogAddressEditVisible = true;
    },
    onAddressSelect() {
      if (this.currentAddress) {
        this.reportInfo.ReportPostID = this.currentAddress.ID
        this.reportInfo.ReportPostInfo = this.currentAddress.Address
      }

      this.currentAddress = null;
      this.addressSelectorWndVisiable = false;
    },
    onEnterpriseTableRowDblClick(row) {
      this.currentEnterprise = row
      this.onEnterpriseSelect()
    },
    onEnterpriseTableRowClick(row) {
      this.currentEnterprise = row
    },
    onEnterpriseSelect() {
      if (this.currentEnterprise) {
        this.proxyInfo.ProxyCustName = this.currentEnterprise.Name
        this.proxyInfo.UscCode = this.currentEnterprise.Certificate
        this.proxyInfo.Linker = this.currentEnterprise.Linker
        this.proxyInfo.LinkerPhone = this.currentEnterprise.LinkTel
        this.proxyInfo.ProxyAddress = this.currentEnterprise.Address
        this.proxyInfo.MakeAddress = this.currentEnterprise.Address
        this.proxyInfo.MakeName = this.currentEnterprise.Name
        this.proxyInfo.ProdCustName = this.currentEnterprise.Name
        this.proxyInfo.ProdCustAddress = this.currentEnterprise.Address
      }

      this.currentEnterprise = null;
      this.enterpriseSelectorWndVisiable = false;
    },
    onRefProxyInfo(name, address) {
      this.proxyInfo[name] = this.proxyInfo.ProxyCustName
      this.proxyInfo[address] = this.proxyInfo.ProxyAddress
    },
    // --打开历史订单选择弹窗
    onSelectHistoryOrderClick() {
      this.historyOrderSelectorVisible = true
      this.historyOrderSearchKey = ''
      this.historyOrderPagination.currentPage = 1
      this.currentHistoryOrder = null
      this.loadHistoryOrders()
    },
    // --加载历史订单列表
    loadHistoryOrders() {
      this.historyOrderLoading = true
      const params = {
        pageSize: this.historyOrderPagination.pageSize,
        currentPage: this.historyOrderPagination.currentPage,
        searchKey: this.historyOrderSearchKey
      }
      GetHistoryOrderList(params).then(res => {
        this.historyOrderLoading = false
        if (res.success) {
          this.historyOrders = res.data.rows || []
          this.historyOrderPagination.total = res.data.total || 0
        } else {
          this.$message.error('获取历史订单失败：' + res.msg)
        }
      }).catch(() => {
        this.historyOrderLoading = false
        this.$message.error('获取历史订单失败')
      })
    },
    // --历史订单分页切换
    onHistoryOrderPageChange(page) {
      this.historyOrderPagination.currentPage = page
      this.loadHistoryOrders()
    },
    // --历史订单行点击
    onHistoryOrderRowClick(row) {
      this.currentHistoryOrder = row
    },
    // --历史订单行双击
    onHistoryOrderRowDblClick(row) {
      this.currentHistoryOrder = row
      this.onHistoryOrderSelect()
    },
    // --确认选择历史订单
    onHistoryOrderSelect() {
      if (!this.currentHistoryOrder) {
        this.$message.warning('请先选择一条历史订单')
        return
      }
      const order = this.currentHistoryOrder
      // 填充申请人信息
      this.applyInfo.CompanyName = order.CompanyName || ''
      this.applyInfo.CompanyAdd = order.CompanyAdd || ''
      this.applyInfo.Linker = order.Linker || ''
      this.applyInfo.LinkerPhone = order.LinkerPhone || ''
      this.applyInfo.CompanyLinkEmail = order.CompanyLinkEmail || ''
      this.applyInfo.PayCompanyName = order.PayCompanyName || ''
      // 填充委托信息
      this.proxyInfo.ProxyCustName = order.ProxyCustName || ''
      this.proxyInfo.ProxyAddress = order.ProxyAddress || ''
      this.proxyInfo.ProdCustName = order.ProdCustName || ''
      this.proxyInfo.ProdCustAddress = order.ProdCustAddress || ''
      this.proxyInfo.MakeName = order.MakeName || ''
      this.proxyInfo.MakeAddress = order.MakeAddress || ''
      // 报告类型
      if (order.ReportLanguage) {
        this.proxyInfo.ReportLanguage = order.ReportLanguage.split(',')
      } else {
        this.proxyInfo.ReportLanguage = []
      }
      // 填充样品信息
      this.reportInfo.SampleName = order.SampleName || ''
      this.reportInfo.SampleModel = order.SampleModel || ''
      this.reportInfo.SampleNum = order.SampleNum || ''
      this.reportInfo.SampleBrand = order.SampleBrand || ''
      this.reportInfo.TrackingNumber = order.TrackingNumber || ''
      this.reportInfo.SampleDispatchDate = order.SampleDispatchDate || ''
      this.reportInfo.CQCNo = order.CQCNo || ''
      this.reportInfo.SampleDisposal = order.SampleDisposal || ''
      this.reportInfo.RecipientName = order.RecipientName || ''
      this.reportInfo.RecipientTel = order.RecipientTel || ''
      this.reportInfo.RecipientAdd = order.RecipientAdd || ''
      this.historyOrderSelectorVisible = false
      this.$message.success('已引用历史订单信息')
    },
    // --确定提交订单
    onPostOrder(Status) {
      if (!this.acceptServiceAgreement) {
        return;
      }
      let _b = true
      this.$refs.applyInfoForm.validate((valid) => {
        _b = _b && valid
      })
      this.$refs.proxyInfoForm.validate((valid) => {
        _b = _b && valid
      })
      this.$refs.reportInfoForm.validate((valid) => {
        _b = _b && valid
      })
      if (!_b) {
        this.$message.error("有必须项验证不通过！")
      } else {
        this.handlePostOrder(Status)
      }
    },
    renderHtml(content) {
      const html = content ? this.escape2Html(content) : ""
      return html;
    },
    /** 提交订单 */
    handlePostOrder(Status) {
      const info = {...this.info}
      if(this.info.Servers && this.info.Servers.length && this.info.Servers.filter(x=>x.IsBuy === '1').length){
        info.Servers = this.info.Servers.filter(x=>x.IsBuy === '1')
      }
      const proxyInfo = {...this.proxyInfo}
      if(Array.isArray(this.proxyInfo.ReportLanguage) && this.proxyInfo.ReportLanguage.length){
        proxyInfo.ReportLanguage = this.proxyInfo.ReportLanguage.join(",")
      }else{
        proxyInfo.ReportLanguage = ""
      }
      if(this.info.ServeName.includes("慧选标品")){
        if(!this.info.OrderFile){
          return this.$message.error("请上传订单附件！")
        }
      }
      
      SaveGoodsOrder({
        ID: this.userSelectData.ID,
        IdNums: JSON.stringify(this.userSelectData.IdNums),
        OrderData: JSON.stringify({
          ...info,
          ...this.applyInfo,
          ...this.reportInfo,
          ...proxyInfo,
          OrderFile: JSON.stringify(this.info.OrderFile),
          IsUrgent: this.info.IsUrgent ? 1 : 0,
          IsEnReport: this.info.IsEnReport ? 1 : 0
        }),
        Status: Status === 'f=Status&v=0' ? 0 : 11
      }).then(res => {
        if (res.success) {
          if(this.info.GoodsDeptID === 1000050){
            this.$message.success('请点击“在线签名”进行签名和生成协议书!')
          }
          Status = 'f=Status&v=0'
          this.$router.push('/center/orders?' + Status)
        } else {
          this.$message.error('操作失败：' + res.msg)
        }
      })
    },
    onSelectAddressClick() {
      const queryParam = {
        Name: 'UserAddress',
        searchEntity: JSON.stringify([]),
        currentPage: 1,
        pageSize: 999
      }
      GetList(queryParam).then(res => {
        if (!res.success) {
          return this.$message.error('用户地址列表获取失败：' + res.msg)
        }

        let userAddress = [...res.data.rows]
        if (!userAddress || !userAddress.length) {
          return this.$message.warning('用户地址列表为空！')
        }

        this.userAddress = userAddress;
        this.addressSelectorWndVisiable = true;
      })
    },
    onUploadFilesChange(files) {
      this.info.OrderFile = files
    },
    onSelectCustClick() {
      const queryParam = {
        Name: 'UserAut',
        searchEntity: JSON.stringify([{
          sqlField: 'AutType',
          pattern: 'Equal',
          value: 2
        }]),
        currentPage: 1,
        pageSize: 999
      }
      GetList(queryParam).then(res => {
        if (!res.success) {
          return this.$message.error('企业认证列表获取失败：' + res.msg)
        }

        let enterprises = [...res.data.rows]
        if (!enterprises || !enterprises.length) {
          return this.$message.warning('企业认证列表为空！')
        }

        this.enterprises = enterprises;
        this.enterpriseSelectorWndVisiable = true;
      })
    },
    showErrorMsg() {
      if (!this.userSelectData.ID) {
        return '参数错误:缺少ID!'
      }
      return this.msg;
    },
    getConfirmOrderInfo() {
      GetGoodsView({
        ID: this.userSelectData.ID,
        IdNums: JSON.stringify(this.userSelectData.IdNums)
      }).then(res => {
        console.log('GetGoodsView', res)
        if (res.success) {
          this.info = { ...res.data, IsUrgent: res.data.IsUrgent === 1 ? true : false, IsEnReport: res.data.IsEnReport === 1 ? true : false }
          this.reportInfoRule.CQCNo = this.reportInfoRule.CQCNo.map(x => {
            x.required = this.info.ServiceNeeds.toUpperCase().includes('CQC') || this.info.ServiceNeeds.toUpperCase().includes('CCC')
            return x;
          });
          if(res.data.TemplateDownload){
            if(Array.isArray(res.data.TemplateDownload)){
              this.TemplateDownload = res.data.TemplateDownload
            }else{
              this.TemplateDownload = JSON.parse(res.data.TemplateDownload)
            }
          }
        } else {
          this.msg = res.msg
        }
      })
    },
    getImgFullPath(url) {
      return url.toUpperCase().startsWith("HTTP") ? url : this.baseUrl + url
    }
  }
}
</script>
<style lang="scss">
.order-confirm-main {
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #fff !important;
    outline: 0;
  }
  .el-button--default {
    margin-top: 1px !important;
    margin-left: 1px !important;
  }
  .el-button--default:focus,
  .el-button--default:hover {
    color: #083090 !important;
    border-color: #fff !important;
    background-color: #fff !important;
  }
}
.el-main {
  background-color: #fff !important;
  padding: 0 !important;
  width: 100% !important;
  min-width: 1226px !important;
  overflow: hidden !important;
  box-sizing: border-box;
  font-size: 12px !important;
}
.margin-top {
  margin-top: 5px;
  .el-descriptions-item__label {
    width: 140px !important;
  }

  &.spc-desc {
    .el-descriptions-item__label {
      width: 300px !important;
      padding-left: 20px !important;
    }
  }
  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }

  .el-input__inner {
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 0px;
    border: 1px solid #fff;
    box-sizing: border-box;
    color: #083090;
    display: inline-block;
    font-size: inherit;
    height: 36px;
    line-height: 36px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #fff;
}
.el-select-dropdown__item.selected {
  color: #083090;
  font-weight: 700;
}

.demo-ruleForm {
  .el-form-item {
    margin: 0;
    .el-input__inner {
      appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 0px;
      border: 1px solid #fff;
      box-sizing: border-box;
      color: #083090;
      display: inline-block;
      font-size: inherit;
      height: 36px;
      line-height: 36px;
      outline: 0;
      padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      background-color: #fff;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 0px solid #dcdfe6;
      border-radius: 0px;
      padding: 0 10px;
      width: 1px;
      white-space: nowrap;
      i {
        font-size: 18px;
        font-weight: bold;
        &.el-icon-question {
          color: #083090;
        }
      }
      &:hover {
        color: #083090 !important;
      }
    }
    .el-form-item__error {
      color: #c10015;
      font-size: 12px;
      line-height: 1;
      padding-top: 0px;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.div-v {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  a {
    font-size: 12px !important;
    &:hover {
      color: #083090;
    }
  }
}
.item-std-label {
  color: #083090;
  &::before {
    content: "✔";
  }
}
.item-price-label {
  color: #083090;
}
.required {
  &::after {
    content: "*";
    color: #c10015;
    font-size: 20px;
    font-weight: bold;
  }
}
.order-confirm-main {
  width: 100%;
  margin: 0 auto;
  max-width: 1226px;
  padding: 10px;
  line-height: 42px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  .page-title {
    color: #ca4300;
  }
}
.order-layout {
  width: 100% !important;
  padding: 0 !important;
  height: auto !important;
}
.goods-info {
  background-color: #fff;
  padding: 0 20px;
  border: 1px solid #f5f5f5;
}
.img-box {
  width: 120px;
  height: 120px;
  padding: 10px;
  img {
    height: 100%;
  }
}
.small-line {
  margin: 0px 10px;
  display: flex;
  align-items: center;
}

.small-title {
  color: #878787;
  font-size: 13px;
  min-width: 66px;
}

.small-text {
  font-size: 15px;
  color: #000;
  font-weight: bold;
}

.capability-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  line-height: 20px;
  padding: 10px 0;
  border-bottom: 1px dashed #f5f5f5;
  font-size: 14px;
}
.item-name {
  color: #083090;
}
.item-name b {
  width: 32px;
  text-align: center;
  margin-right: 5px;
}
.item-std {
  padding: 0 10px;
  color: #000;
  font-size: 12px;
}
.capability-item:last-child {
  border-bottom: 0px dashed #f5f5f5;
}

.capability-item .item-right {
  display: inline-block;
  font-size: 15px;
  width: 100px;
  color: #000;
  text-align: right;
}
.item-price {
  display: inline-block;
  color: #ca4300;
  font-size: 19px;
  font-weight: 600;
  min-width: 60px;

  &.item-price-2 {
    margin-left: 10px;
    display: inline-block;
    color: #ca4300;
    font-size: 14px;
    font-weight: 500;
    width: 60px;
  }
}

.capability-item .item-line {
  width: 100%;
  min-height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.capability-item .item-line-2 {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.item-price::before {
  color: #ca4300;
  content: "￥";
  font-size: 11px;
}
.item-line-2 > div {
  padding-top: 5px;
  padding-bottom: 5px;
}
.item-line-2 > div::before {
  content: "◉";
  padding-right: 5px;
  color: #666;
}
.item-price-type {
  padding: 0 5px;
  font-size: 14px;
  font-weight: 600;
  color: #083090;
}
.item-price-type::before {
  content: "【";
}
.item-price-type::after {
  content: "】";
}
.html-box {
  max-height: 600px;
  overflow-y: scroll;
}
</style>